import { api } from './client'
import type { ExportPreviewResponse } from './types'

export interface ExportRequest {
  qboCompanyId: string | null
  entityType: string
  reference?: string
  dateMode: 'preset' | 'custom'
  preset?: string
  from?: string
  to?: string
}

export interface ExportPreviewRequest extends ExportRequest {
  qboCompanyId: string
  page?: number
  pageSize?: number
}

/**
 * `POST /api/export/submit` queues a real export job and returns `{ jobId }`.
 * The worker queries QuickBooks, writes a CSV to blob storage and hangs it off
 * the job, so the file is fetched from the job rather than from this response.
 *
 * `POST /api/export/preview` runs that same query inline (read-only, never
 * persists) and returns one page of actual records, so the wizard's step-2
 * count and step-3 preview show real QuickBooks data instead of placeholders.
 */
export const exportApi = {
  submit(request: ExportRequest): Promise<{ jobId: string }> {
    return api.post<{ jobId: string }>('/export/submit', request)
  },

  preview(request: ExportPreviewRequest): Promise<ExportPreviewResponse> {
    return api.post<ExportPreviewResponse>('/export/preview', request)
  },
}
